import React from 'react';

export function UsersIcon(filled?: boolean) {
  // https://lucide.dev/icons/users
  return (
    <g
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path
        d={`M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2${filled ? 'z' : ''}`}
        fill={filled ? 'currentColor' : 'none'}
      />
      <path d="M16 3.128a4 4 0 0 1 0 7.744" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <circle cx="9" cy="7" r="4" fill={filled ? 'currentColor' : 'none'} />
    </g>
  );
}
